module.exports = "/fonts/NotoSans-Regular.ttf?c8e58befd2433eb89589dd1d23225c4e";